import React, { createContext, useContext, useState } from 'react';

// Define the shape of the context
interface EditorContextType {
  editorInstance: any; // Replace with the actual type of the editor instance
  setEditorInstance: (editor: any) => void;
}

// Create context with default values
const EditorContext = createContext<EditorContextType>({
  editorInstance: null,
  setEditorInstance: () => {},
});

// Custom hook to use editor context
export const useEditorContext = () => useContext(EditorContext);

// EditorProvider component that provides the context
export const EditorProvider = ({ children }: { children: React.ReactNode }) => {
  const [editorInstance, setEditorInstance] = useState<any>(null);

  return (
    <EditorContext.Provider value={{ editorInstance, setEditorInstance }}>
      {children}
    </EditorContext.Provider>
  );
};
